import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useMemo, useState } from "react";

import AuthService from "../../../utilities/services/auth.service";
import { isOn } from "../../../featureFlags/growthbook";

import AssignModalForm from "./AssignModalForm";

export default function AssignTicketsModalContent({
  event,
  eventPackage,
  selectedSeatIds,
  data,
  initialAssignTo,
  initialPaymentMethod,
  sourceOrderId,
  reloadAssignments,
}) {
  const organization = AuthService.getOrg()?.[0];

  // Prefer deriving the connected account from the item being sold (event/package),
  // since admins can belong to multiple orgs and AuthService.getOrg()[0] may not match.
  const isProd = process.env.REACT_APP_STAGE === "production";

  const paymentOrg =
    event?.organization || eventPackage?.organization || organization;

  const connectedAccountId = isProd
    ? paymentOrg?.connected_account_id
    : paymentOrg?.test_connected_account_id;

  // Validate Stripe key is present
  if (!process.env.REACT_APP_STRIPE_KEY) {
    console.error(
      "REACT_APP_STRIPE_KEY is not set. Please check your environment variables.",
    );
  }

  const isDemoOrPreview =
    process.env.REACT_APP_STAGE === "demo" ||
    process.env.REACT_APP_STAGE === "preview";
  const [stripeAccountContext, setStripeAccountContext] = useState(() =>
    paymentOrg?.destinationAccount === false
      ? connectedAccountId
      : isDemoOrPreview || paymentOrg?.destinationAccount === true
        ? null
        : connectedAccountId,
  );

  const stripePromise = useMemo(
    () =>
      loadStripe(
        process.env.REACT_APP_STRIPE_KEY,
        stripeAccountContext
          ? { stripeAccount: stripeAccountContext }
          : undefined,
      ),
    [stripeAccountContext],
  );

  // Dynamically provide ticketType
  const ticketTypeKey = Object.keys(selectedSeatIds || {})[0];
  let selectedCount = 0;
  if (ticketTypeKey === "gaSeats") {
    const gaSeatsBySection = selectedSeatIds?.[ticketTypeKey] || {};
    selectedCount = Object.values(gaSeatsBySection).reduce(
      (count, sectionSeats) => count + (sectionSeats?.length || 0),
      0,
    );
  } else if (ticketTypeKey === "seats") {
    const seats = selectedSeatIds?.[ticketTypeKey] || {};
    selectedCount = Object.keys(seats).length;
  }

  const typeOfTickets = selectedCount < 20 ? "individual" : "group";
  // Creating a new order
  return (
    <Elements stripe={stripePromise}>
      <AssignModalForm
        ticketType={typeOfTickets}
        event={event}
        eventPackage={eventPackage}
        selectedSeatIds={selectedSeatIds}
        data={data}
        initialAssignTo={initialAssignTo}
        initialPaymentMethod={initialPaymentMethod}
        sourceOrderId={sourceOrderId}
        reloadAssignments={reloadAssignments}
        connectedAccountId={connectedAccountId}
        stripeAccountContext={stripeAccountContext}
        onStripeAccountContextChange={setStripeAccountContext}
      />
    </Elements>
  );
}
